import { useCallback } from 'react';

import {
  OpenBankingIbanCreate,
  OpenBankingIbanConsent,
  OpenBankingPayment,
  OpenBankingService,
  RequiredDataType
} from 'openapi';

import { useInterceptor } from 'hooks/useInterceptor';

export const useOpenBankingController = () => {
  const { interceptRequest } = useInterceptor();

  const {
    createIban,
    consentIban,
    deleteIban,
    signUp,
    signOut,
    initiatePayment,
    getRequiredData
  } = OpenBankingService;

  const createIbanByCompanyId = useCallback(
    (companyId: number, ibanId: number, requestBody: OpenBankingIbanCreate) =>
      interceptRequest(createIban, {}, companyId, ibanId, requestBody),
    [createIban]
  );

  const consentIbanByCompanyId = useCallback(
    (companyId: number, ibanId: number, requestBody: OpenBankingIbanConsent) =>
      interceptRequest(consentIban, {}, companyId, ibanId, requestBody),
    [consentIban]
  );

  const deleteIbanByCompanyId = useCallback(
    (companyId: number, ibanId: number) =>
      interceptRequest(deleteIban, {}, companyId, ibanId),
    [deleteIban]
  );

  const signUpToOpenBanking = useCallback(
    (companyId: number) => interceptRequest(signUp, {}, companyId),
    [signUp]
  );

  const signOutFromOpenBanking = useCallback(
    (companyId: number) => interceptRequest(signOut, {}, companyId),
    [signOut]
  );

  const initiatePaymentByCompanyId = useCallback(
    (companyId: number, ibanId: number, requestBody: OpenBankingPayment) =>
      interceptRequest(initiatePayment, {}, companyId, ibanId, requestBody),
    [initiatePayment]
  );

  const getOpenBankingRequiredData = useCallback(
    (companyId: number, ibanId: number, type: RequiredDataType) =>
      interceptRequest(getRequiredData, {}, companyId, ibanId, type),
    [getRequiredData]
  );

  return {
    createIbanByCompanyId,
    consentIbanByCompanyId,
    deleteIbanByCompanyId,
    signUpToOpenBanking,
    signOutFromOpenBanking,
    initiatePaymentByCompanyId,
    getOpenBankingRequiredData
  };
};
